import { useEffect, useRef } from "react";

import wrapSelectionEnsureSingle from "./wrapClozeSelection";

const WRAP_DEBOUNCE_MS = 250;

// Shared "highlight text to make it the cloze" behavior for the quick capture
// textareas. Highlighting a range - or double clicking a word - rewrites the
// text so that only that range is wrapped in {{ }}, replacing any existing
// wrapper, so there's no need to delete the old braces and retype them.
//
// Returns a ref to attach to the textarea and an onSelect handler.
export default function useClozeSelection(setValue) {
  const ref = useRef(null);
  const wrapTimer = useRef(null);

  useEffect(() => {
    return () => {
      if(wrapTimer.current) clearTimeout(wrapTimer.current);
    };
  }, []);

  const onSelect = (e) => {
    const start = e.target.selectionStart;
    const end = e.target.selectionEnd;

    if(wrapTimer.current) clearTimeout(wrapTimer.current);
    if(start === end) return;

    wrapTimer.current = setTimeout(() => {
      const el = ref.current;
      if(!el || document.activeElement !== el) return;
      if(el.selectionStart !== start || el.selectionEnd !== end) return;

      setValue((prev) => {
        const { nextText, nextSelection } = wrapSelectionEnsureSingle(prev, start, end);
        if(nextText === prev) return prev;
        setTimeout(() => {
          if(ref.current) ref.current.setSelectionRange(nextSelection.start, nextSelection.end);
        }, 0);
        return nextText;
      });
    }, WRAP_DEBOUNCE_MS);
  };

  return { onSelect, ref };
}
